export const SENTIMENT = {
  veryDisappointed: 'Very disappointed',
  somewhatDisappointed: 'Somewhat disappointed',
  notDisappointed: 'Not disappointed',
}

export const EASE_OF_USE = {
  veryDifficult: 'Very difficult',
  somewhatDifficult: 'Somewhat difficult',
  neutral: 'Neutral',
  somewhatEasy: 'Somewhat easy',
  veryEasy: 'Very easy',
}
